<div #selectContainer class="fc-custom-select">
  <div (click)="displayOptions = !displayOptions" class="fc-custom-select__label">
    <span class="fc-custom-select__label__selected-option">{{
      selectedOption && selectedOption.name ? selectedOption.name : label
    }}</span>
    <mat-icon class="fc-custom-select__label__icon">arrow_drop_down</mat-icon>
  </div>
  <div class="fc-custom-select__options" *ngIf="displayOptions">
    <input
      [(ngModel)]="search"
      class="fc-custom-select__options__search"
      [placeholder]="('FC_CUSTOM_SELECT.SEARCH' | translate) + ' ' + label"
    />
    <div class="fc-custom-select__options__option-list">
      <div
        (click)="selectOption(option)"
        *ngFor="let option of filteredOptions"
        class="fc-custom-select__options__option-list__option"
      >
        <mat-icon *ngIf="option === selectedOption">check</mat-icon>
        <span class="fc-custom-select__options__option-list__option__name">{{ option.name }}</span>
        <span (click)="editOption($event, option)" class="fc-custom-select__options__option-list__option__edit">
          {{ 'FC_CUSTOM_SELECT.EDIT' | translate }}</span
        >
      </div>
      <span class="fc-custom-select__options__option-list__no-options" *ngIf="!filteredOptions.length">
        {{ 'FC_CUSTOM_SELECT.NO_OPTIONS' | translate }}
      </span>
    </div>
    <button (click)="addOption($event)" class="fc-custom-select__options__button">
      {{ ('FC_CUSTOM_SELECT.CREATE_NEW' | translate) + ' ' + label }}
    </button>
  </div>
</div>
